export default __webpack_public_path__ + "static/media/orchid_tracking.100d8bb4.svg";